import {
  INFLUENCER_ADDITIONAL_CONFIGS,
  type InfluencerCampaigns,
  isInfluencerCampaignKey,
} from '../influencers.config';

type InfluencerAdditionalConfigs = (typeof INFLUENCER_ADDITIONAL_CONFIGS)[InfluencerCampaigns];

export const useInfluencerAdditionalConfigs = (
  influencerCampaign: string | undefined,
): InfluencerAdditionalConfigs | null => {
  if (influencerCampaign && isInfluencerCampaignKey(influencerCampaign)) {
    return INFLUENCER_ADDITIONAL_CONFIGS[influencerCampaign] ?? null;
  }

  return null;
};
